import type { Column } from "@tanstack/react-table";

/** Human label for a column: explicit meta.label → string header → id. */
export function columnLabel<TData, TValue>(column: Column<TData, TValue>): string {
  const label = column.columnDef.meta?.label;
  if (label) return label;
  const header = column.columnDef.header;
  if (typeof header === "string") return header;
  return column.id;
}

/** Columns worth listing in the visibility menu / exporting (real data, not chrome). */
export function isDataColumn<TData, TValue>(column: Column<TData, TValue>): boolean {
  return column.accessorFn != null || column.columnDef.meta?.label != null;
}

/** Escape a single CSV cell per RFC 4180. */
export function toCsvCell(value: unknown): string {
  if (value == null) return "";
  const text =
    typeof value === "object" ? JSON.stringify(value) : String(value as string | number | boolean);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}
